import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

import {
  getChat,
  setHoldPulling,
  setMessagesAsRead,
} from "../../Store/actions/index";

import classes from "./Chat.module.css";

const Chat = ({ chatMessages, userId, chatId }) => {
  const timerIdRef = useRef(null);

  const lengthRef = useRef(0);

  const messageEndRef = useRef(null);

  const isGoodBrowser =
    (!!window.chrome &&
      (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    /*@cc_on!@*/ false ||
    !!document.documentMode ||
    typeof InstallTrigger !== "undefined";

  let chats = null;

  const { holdPulling, pagination_info, updating } = useSelector(
    (state) => state.Chat
  );

  const dispatch = useDispatch();

  const handleToggleInterval = (hold) => {
    clearInterval(timerIdRef.current);

    if (!hold) {
      timerIdRef.current = setInterval(() => {
        dispatch(getChat(chatId));
      }, 10000);
    }
  };

  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView();
    }
    timerIdRef.current = setInterval(() => {
      dispatch(getChat(chatId));
    }, 10000);

    return () => {
      clearInterval(timerIdRef.current);
    };
  }, [chatId]);

  useEffect(() => {
    if (messageEndRef.current && lengthRef.current < chatMessages.length) {
      lengthRef.current = chatMessages.length;
      messageEndRef.current.scrollIntoView();
    }

    if ((lengthRef.current = chatMessages.length)) {
      dispatch(setMessagesAsRead(chatMessages, userId));
    }
  }, [chatMessages]);

  useEffect(() => {
    handleToggleInterval(holdPulling);
  }, [holdPulling]);

  if (chatMessages) {
    chats = chatMessages.map((chat) => {
      return (
        <div ref={messageEndRef} className={classes.ChatRow} key={chat.id}>
          {chat.receiver_id !== +userId ? (
            <div className={classes.Reciver}>
              {chat.media && <img src={chat.media.url} />}
              <p>{chat.message}</p>
              {chat.lightRight ? (
                <div className={classes.LightRight}></div>
              ) : null}
              <small>
                {isGoodBrowser
                  ? new Date(chat.created_at).toString().slice(4, 21)
                  : chat.created_at.slice(0, -3)}
                {chat.read_at ? "  ,Seen" : null}
              </small>
            </div>
          ) : (
            <div className={classes.Sender}>
              {chat.media && <img src={chat.media.url} />}
              <p>{chat.message}</p>
              <small>
                {isGoodBrowser
                  ? new Date(chat.created_at).toString().slice(4, 21)
                  : chat.created_at.slice(0, -3)}
              </small>
            </div>
          )}
        </div>
      );
    });
  }

  return (
    <div
      className={classes.Container}
      onScroll={(event) => {
        if (event.target.scrollTop === 0 && pagination_info) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          dispatch(
            getChat(chatId, (+pagination_info.chat_page + 1).toString(), true)
          );
          dispatch(setHoldPulling(true));
        } else if (
          event.target.scrollHeight - event.target.scrollTop ===
          event.target.clientHeight
        )
          dispatch(setHoldPulling(false));
      }}
    >
      {updating && (
        <div className="d-flex justify-content-center">
          <Spinner animation="grow" />
          <Spinner animation="grow" />
          <Spinner animation="grow" />
        </div>
      )}
      {chats}
    </div>
  );
};

export default Chat;
